import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Notice = ({ className }) => (
  <div className={className}>
    <h3>Avertissement</h3>
    <p>
      Vous vous apprêtez à envoyer une notification à toutes les personnes intéressées par ce villageois.
      <br/>
      Assurez-vous d'avoir accès au serveur Discord du Perchoir et d'avoir vos messages privés ouverts.
    </p>
  </div>
);

Notice.propTypes = { className: PropTypes.string.isRequired };

export default styled(Notice)`
  h3 {
    color: hsl(0, 79%, 72%);
    text-transform: uppercase;
    margin: 1rem 0;
    font-weight: bold;
  }
  p {
    font-size: 1rem;
    font-weight: bold;
  }
`;
